module.exports = __webpack_public_path__ + "media/images/font/SofiaProLight-2ced34b69de77c5a83be99e8cf981e1b.svg";